import React from 'react';

const eyeIcon = require('@app/images/icons/eye-open.svg');
const eyeCrossedIcon = require('@app/images/icons/eye-crossed.svg');

const PasswordShowHide = ({ field, form, placeholder }) => {
	const [showHidePassword, changeShowHidePassword] = React.useState(false);
	const hasError = form.touched[field.name] && form.errors[field.name];

	return (
		<div className="input-container">
			<input
				type={showHidePassword ? 'text' : 'password'}
				{...field}
				className={hasError ? 'input-error input-field' : 'input-field'}
				placeholder={placeholder}
			/>

			<div className="custom-input__suffix-icon" onClick={() => changeShowHidePassword(!showHidePassword)}>
				<img src={showHidePassword ? eyeIcon : eyeCrossedIcon} alt="ShowHide" />
			</div>
		</div>
	);
};

export default PasswordShowHide;
